import React from "react";
import { Card, notification } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { Upload } from "antd";
import xlsx from "xlsx";
import { useMutation } from "@apollo/react-hooks";
import { OrgGql } from "../../../graphql/organization";
const { Dragger } = Upload;

interface IStudent {
  id: string;
  childFirstName: string;
  childLastName: string;
  childGrade: string;
  childEmail: string;
  parentFirstName: string;
  parentLastName: string;
  parentEmail: string;
  parentMobile: string;
}

const cvtStudents = (orgId, wb) => {
  let list = xlsx.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
  return list.map((x: any) => {
    return {
      orgId,
      childFirstName: x["student first name"],
      childLastName: x["student last name"],
      childGrade: x["student grade"],
      childEmail: x["student email"],
      parentFirstName: x["parent first name"],
      parentLastName: x["parent last name"],
      parentEmail: x["parent email"],
      parentMobile: x["parent mobile"],
      errors: [],
    };
  });
};

export const OrgUpload = ({ orgId, onLoaded }) => {
  const [uploadOrgData] = useMutation(OrgGql.uploadOrgData);

  const upload = (file) => {
    var reader = new FileReader();
    reader.onload = (e: any) => {
      var data = new Uint8Array(e.target.result);
      var wb = xlsx.read(data, { type: "array" });
      const newStudents = cvtStudents(orgId, wb);
      if (newStudents.length === 0) {
        notification.error({ message: "Can not find any data." });
      } else {
        onLoaded && onLoaded(newStudents);
        uploadOrgData({ variables: { input: newStudents } }).then((res) => {
          console.log("uploaded", res);
          onLoaded && onLoaded(res.data.uploadOrgData);
        });
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const props = {
    name: "file",
    accept: ".xls,.xlsx",
    showUploadList: false,
    beforeUpload: (file) => {
      upload(file);
      return false;
    },
  };

  return (
    <Card>
      <Dragger {...props}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">Click or drag file to this area to upload</p>
        <p className="ant-upload-hint">
          You can{" "}
          <a
            href="/import_data_tmpl.xlsx"
            target="_blank"
            download="import_data_tmpl.xlsx"
            onClick={(e) => e.stopPropagation()}
          >
            download template file
          </a>{" "}
          to input students info.
        </p>
      </Dragger>
    </Card>
  );
};
